import { createSlice } from '@reduxjs/toolkit';
import { fetchFreeTrialStatus } from '@/data/freetrial/actions/fetchFreeTrialStatus';
import FreeTrial from '@/data/freetrial/model';
import FreeTrialState from '@/data/freetrial/state';
import generateThunkReducers from '@/data/util/generateThunkReducers';

export const freeTrialSlice = createSlice({
  name: 'freeTrial',
  initialState: new FreeTrialState(),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchFreeTrialStatus.fulfilled, (state, action) => {
      return state.merge({
        trialStatus: new FreeTrial(action.payload),
      });
    });
    generateThunkReducers(builder, 'freeTrial');
  },
});

export default freeTrialSlice.reducer;
